// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.webhooks-page {
    min-height: 100vh;
    background: #f5f5f5;
}

.page-header {
    background: white;
    padding: 20px 40px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.page-header h1 {
    margin: 0;
    color: #333;
    font-size: 24px;
}

.user-info {
    margin: 5px 0 0 0;
    color: #666;
    font-size: 14px;
}

.badge {
    display: inline-block;
    padding: 2px 8px;
    background: #667eea;
    color: white;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
    margin-left: 8px;
    text-transform: uppercase;
}

.header-actions {
    display: flex;
    gap: 10px;
}

.secondary-btn {
    padding: 8px 20px;
    background: #6c757d;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    width: auto;
}

.secondary-btn:hover {
    background: #5a6268;
}

.logout-btn {
    padding: 8px 20px;
    background: #dc3545;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    width: auto;
}

.logout-btn:hover {
    background: #c82333;
}

.page-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 40px 20px;
}

.page-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
}

.page-actions h2 {
    margin: 0;
    color: #333;
}

.primary-btn {
    padding: 10px 20px;
    background: #667eea;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    width: auto;
}

.primary-btn:hover {
    background: #5568d3;
}

.error {
    background: #fee;
    color: #c33;
    padding: 15px;
    border-radius: 5px;
    margin-bottom: 20px;
}

.success {
    background: #d4edda;
    color: #155724;
    padding: 15px;
    border-radius: 5px;
    margin-bottom: 20px;
}

.loading {
    text-align: center;
    padding: 40px;
    color: #666;
    font-size: 16px;
}

.empty-state {
    text-align: center;
    padding: 60px 20px;
    background: white;
    border-radius: 10px;
    color: #666;
}

.empty-state p {
    font-size: 16px;
}

.webhooks-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    gap: 20px;
}

.webhook-card {
    background: white;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    transition: transform 0.2s, box-shadow 0.2s;
}

.webhook-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.webhook-card-header {
    padding: 20px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.webhook-card-header h3 {
    margin: 0;
    color: #333;
    font-size: 18px;
    flex: 1 1;
}

.format-badge {
    padding: 3px 10px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    background: #cfe2ff;
    color: #084298;
    margin-left: 10px;
}

.webhook-card-body {
    padding: 20px;
}

.info-row {
    margin-bottom: 12px;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.info-row .label {
    font-size: 12px;
    color: #666;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.info-row .value {
    color: #333;
    font-size: 14px;
}

.response-code {
    background: #f8f9fa;
    padding: 8px 12px;
    border-radius: 4px;
    font-family: 'Courier New', monospace;
    font-size: 13px;
    color: #495057;
    display: inline-block;
}

.truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.webhook-card-footer {
    padding: 15px 20px;
    background: #f8f9fa;
    border-top: 1px solid #eee;
    display: flex;
    gap: 10px;
}

.edit-btn {
    flex: 1 1;
    padding: 10px;
    background: #667eea;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
}

.edit-btn:hover {
    background: #5568d3;
}

.delete-btn {
    flex: 1 1;
    padding: 10px;
    background: #dc3545;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
}

.delete-btn:hover {
    background: #c82333;
}

/* Modal Styles */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.modal-content {
    background: white;
    border-radius: 10px;
    width: 90%;
    max-width: 600px;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.modal-header {
    padding: 20px 30px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-header h2 {
    margin: 0;
    color: #333;
    font-size: 20px;
}

.close-btn {
    background: none;
    border: none;
    font-size: 32px;
    color: #999;
    cursor: pointer;
    padding: 0;
    width: 32px;
    height: 32px;
    line-height: 1;
}

.close-btn:hover {
    color: #333;
}

.modal-content form {
    padding: 30px;
}

.form-group {
    margin-bottom: 20px;
}

.form-group label {
    display: block;
    margin-bottom: 8px;
    color: #555;
    font-weight: 600;
    font-size: 14px;
}

.form-group input,
.form-group select {
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 14px;
    box-sizing: border-box;
}

.form-group input:focus,
.form-group select:focus {
    outline: none;
    border-color: #667eea;
}

.form-group small {
    display: block;
    margin-top: 4px;
    color: #666;
    font-size: 12px;
}

.modal-footer {
    padding: 20px 30px;
    border-top: 1px solid #eee;
    display: flex;
    gap: 10px;
    background: #f8f9fa;
}

.modal-footer button {
    flex: 1 1;
    padding: 10px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
}

/* Webhook Execution Logs Section */
.execution-logs-section {
    margin-top: 60px;
    padding-top: 40px;
    border-top: 2px solid #e0e0e0;
}

.execution-logs-section h2 {
    margin: 0 0 8px 0;
    color: #333;
    font-size: 22px;
}

.section-description {
    margin: 0 0 20px 0;
    color: #666;
    font-size: 14px;
}

.logs-table-container {
    background: white;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    overflow-x: auto;
}

.logs-table {
    width: 100%;
    border-collapse: collapse;
}

.logs-table thead {
    background: #f8f9fa;
}

.logs-table th {
    padding: 12px 15px;
    text-align: left;
    font-weight: 600;
    color: #333;
    border-bottom: 2px solid #dee2e6;
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.logs-table td {
    padding: 12px 15px;
    border-bottom: 1px solid #dee2e6;
    font-size: 14px;
    color: #333;
}

.logs-table tbody tr:hover {
    background: #f8f9fa;
}

.logs-table tbody tr:last-child td {
    border-bottom: none;
}

.attempt-badge {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
}

.attempt-badge.first {
    background: #d1ecf1;
    color: #0c5460;
}

.attempt-badge.retry {
    background: #fff3cd;
    color: #856404;
}

.status-badge {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
}

.status-badge.status-success {
    background: #d4edda;
    color: #155724;
}

.status-badge.status-failure {
    background: #f8d7da;
    color: #721c24;
}

.status-badge.status-timeout {
    background: #fff3cd;
    color: #856404;
}

.status-badge.status-error {
    background: #f8d7da;
    color: #721c24;
}

.error-message {
    max-width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #666;
    font-size: 13px;
}

.dashboard-nav {
    background: white;
    padding: 0 40px;
    border-bottom: 1px solid #eee;
    display: flex;
    gap: 10px;
}

.nav-btn {
    background: none;
    border: none;
    padding: 15px 20px;
    cursor: pointer;
    font-size: 14px;
    color: #666;
    border-bottom: 2px solid transparent;
    transition: all 0.2s;
}

.nav-btn:hover {
    color: #667eea;
}

.nav-btn.active {
    color: #667eea;
    border-bottom-color: #667eea;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Webhooks.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,wCAAwC;IACxC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,wCAAwC;IACxC,gBAAgB;IAChB,2CAA2C;AAC/C;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,WAAW;IACX,eAAe;IACf,SAAO;AACX;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;IACf,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,0BAA0B;IAC1B,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,eAAe;IACf,UAAU;IACV,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;;IAEI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA,mCAAmC;AACnC;IACI,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,wCAAwC;IACxC,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,gCAAgC;IAChC,eAAe;IACf,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,6BAA6B;IAC7B,aAAa;IACb,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,WAAW;IACX,oCAAoC;IACpC,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,4BAA4B;AAChC","sourcesContent":[".webhooks-page {\n    min-height: 100vh;\n    background: #f5f5f5;\n}\n\n.page-header {\n    background: white;\n    padding: 20px 40px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.page-header h1 {\n    margin: 0;\n    color: #333;\n    font-size: 24px;\n}\n\n.user-info {\n    margin: 5px 0 0 0;\n    color: #666;\n    font-size: 14px;\n}\n\n.badge {\n    display: inline-block;\n    padding: 2px 8px;\n    background: #667eea;\n    color: white;\n    border-radius: 12px;\n    font-size: 11px;\n    font-weight: 600;\n    margin-left: 8px;\n    text-transform: uppercase;\n}\n\n.header-actions {\n    display: flex;\n    gap: 10px;\n}\n\n.secondary-btn {\n    padding: 8px 20px;\n    background: #6c757d;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 14px;\n    width: auto;\n}\n\n.secondary-btn:hover {\n    background: #5a6268;\n}\n\n.logout-btn {\n    padding: 8px 20px;\n    background: #dc3545;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 14px;\n    width: auto;\n}\n\n.logout-btn:hover {\n    background: #c82333;\n}\n\n.page-content {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 40px 20px;\n}\n\n.page-actions {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 30px;\n}\n\n.page-actions h2 {\n    margin: 0;\n    color: #333;\n}\n\n.primary-btn {\n    padding: 10px 20px;\n    background: #667eea;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 600;\n    width: auto;\n}\n\n.primary-btn:hover {\n    background: #5568d3;\n}\n\n.error {\n    background: #fee;\n    color: #c33;\n    padding: 15px;\n    border-radius: 5px;\n    margin-bottom: 20px;\n}\n\n.success {\n    background: #d4edda;\n    color: #155724;\n    padding: 15px;\n    border-radius: 5px;\n    margin-bottom: 20px;\n}\n\n.loading {\n    text-align: center;\n    padding: 40px;\n    color: #666;\n    font-size: 16px;\n}\n\n.empty-state {\n    text-align: center;\n    padding: 60px 20px;\n    background: white;\n    border-radius: 10px;\n    color: #666;\n}\n\n.empty-state p {\n    font-size: 16px;\n}\n\n.webhooks-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n    gap: 20px;\n}\n\n.webhook-card {\n    background: white;\n    border-radius: 10px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    overflow: hidden;\n    transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.webhook-card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.webhook-card-header {\n    padding: 20px;\n    border-bottom: 1px solid #eee;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n}\n\n.webhook-card-header h3 {\n    margin: 0;\n    color: #333;\n    font-size: 18px;\n    flex: 1;\n}\n\n.format-badge {\n    padding: 3px 10px;\n    border-radius: 12px;\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.3px;\n    background: #cfe2ff;\n    color: #084298;\n    margin-left: 10px;\n}\n\n.webhook-card-body {\n    padding: 20px;\n}\n\n.info-row {\n    margin-bottom: 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.info-row .label {\n    font-size: 12px;\n    color: #666;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.info-row .value {\n    color: #333;\n    font-size: 14px;\n}\n\n.response-code {\n    background: #f8f9fa;\n    padding: 8px 12px;\n    border-radius: 4px;\n    font-family: 'Courier New', monospace;\n    font-size: 13px;\n    color: #495057;\n    display: inline-block;\n}\n\n.truncate {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.webhook-card-footer {\n    padding: 15px 20px;\n    background: #f8f9fa;\n    border-top: 1px solid #eee;\n    display: flex;\n    gap: 10px;\n}\n\n.edit-btn {\n    flex: 1;\n    padding: 10px;\n    background: #667eea;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.edit-btn:hover {\n    background: #5568d3;\n}\n\n.delete-btn {\n    flex: 1;\n    padding: 10px;\n    background: #dc3545;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.delete-btn:hover {\n    background: #c82333;\n}\n\n/* Modal Styles */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n}\n\n.modal-content {\n    background: white;\n    border-radius: 10px;\n    width: 90%;\n    max-width: 600px;\n    max-height: 90vh;\n    overflow-y: auto;\n    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n}\n\n.modal-header {\n    padding: 20px 30px;\n    border-bottom: 1px solid #eee;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.modal-header h2 {\n    margin: 0;\n    color: #333;\n    font-size: 20px;\n}\n\n.close-btn {\n    background: none;\n    border: none;\n    font-size: 32px;\n    color: #999;\n    cursor: pointer;\n    padding: 0;\n    width: 32px;\n    height: 32px;\n    line-height: 1;\n}\n\n.close-btn:hover {\n    color: #333;\n}\n\n.modal-content form {\n    padding: 30px;\n}\n\n.form-group {\n    margin-bottom: 20px;\n}\n\n.form-group label {\n    display: block;\n    margin-bottom: 8px;\n    color: #555;\n    font-weight: 600;\n    font-size: 14px;\n}\n\n.form-group input,\n.form-group select {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    font-size: 14px;\n    box-sizing: border-box;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n    outline: none;\n    border-color: #667eea;\n}\n\n.form-group small {\n    display: block;\n    margin-top: 4px;\n    color: #666;\n    font-size: 12px;\n}\n\n.modal-footer {\n    padding: 20px 30px;\n    border-top: 1px solid #eee;\n    display: flex;\n    gap: 10px;\n    background: #f8f9fa;\n}\n\n.modal-footer button {\n    flex: 1;\n    padding: 10px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 600;\n}\n\n/* Webhook Execution Logs Section */\n.execution-logs-section {\n    margin-top: 60px;\n    padding-top: 40px;\n    border-top: 2px solid #e0e0e0;\n}\n\n.execution-logs-section h2 {\n    margin: 0 0 8px 0;\n    color: #333;\n    font-size: 22px;\n}\n\n.section-description {\n    margin: 0 0 20px 0;\n    color: #666;\n    font-size: 14px;\n}\n\n.logs-table-container {\n    background: white;\n    border-radius: 10px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    overflow-x: auto;\n}\n\n.logs-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.logs-table thead {\n    background: #f8f9fa;\n}\n\n.logs-table th {\n    padding: 12px 15px;\n    text-align: left;\n    font-weight: 600;\n    color: #333;\n    border-bottom: 2px solid #dee2e6;\n    font-size: 13px;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.logs-table td {\n    padding: 12px 15px;\n    border-bottom: 1px solid #dee2e6;\n    font-size: 14px;\n    color: #333;\n}\n\n.logs-table tbody tr:hover {\n    background: #f8f9fa;\n}\n\n.logs-table tbody tr:last-child td {\n    border-bottom: none;\n}\n\n.attempt-badge {\n    display: inline-block;\n    padding: 4px 10px;\n    border-radius: 12px;\n    font-size: 12px;\n    font-weight: 600;\n}\n\n.attempt-badge.first {\n    background: #d1ecf1;\n    color: #0c5460;\n}\n\n.attempt-badge.retry {\n    background: #fff3cd;\n    color: #856404;\n}\n\n.status-badge {\n    display: inline-block;\n    padding: 4px 10px;\n    border-radius: 12px;\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n}\n\n.status-badge.status-success {\n    background: #d4edda;\n    color: #155724;\n}\n\n.status-badge.status-failure {\n    background: #f8d7da;\n    color: #721c24;\n}\n\n.status-badge.status-timeout {\n    background: #fff3cd;\n    color: #856404;\n}\n\n.status-badge.status-error {\n    background: #f8d7da;\n    color: #721c24;\n}\n\n.error-message {\n    max-width: 300px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    color: #666;\n    font-size: 13px;\n}\n\n.dashboard-nav {\n    background: white;\n    padding: 0 40px;\n    border-bottom: 1px solid #eee;\n    display: flex;\n    gap: 10px;\n}\n\n.nav-btn {\n    background: none;\n    border: none;\n    padding: 15px 20px;\n    cursor: pointer;\n    font-size: 14px;\n    color: #666;\n    border-bottom: 2px solid transparent;\n    transition: all 0.2s;\n}\n\n.nav-btn:hover {\n    color: #667eea;\n}\n\n.nav-btn.active {\n    color: #667eea;\n    border-bottom-color: #667eea;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
